import { Navigate, useParams } from 'react-router-dom';

// ----------------------------------------------------------------------

type RedirectWithParamsProps = {
  to: string;
};

/**
 * A Navigate wrapper that resolves `:paramName` placeholders in the `to` prop
 * using the current route parameters from `useParams()`.
 *
 * Use this instead of `<Navigate>` when the redirect target contains dynamic
 * route parameters (e.g. `:id`, `:orderId`).
 */
export function RedirectWithParams({ to }: RedirectWithParamsProps) {
  const params = useParams();

  const resolved = to.replace(/:([a-zA-Z_]+)/g, (match, paramName) => params[paramName] ?? '');

  return <Navigate to={resolved} replace />;
}
